import { Component, Input, OnInit } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ArchiveService } from '../shared/services/archive.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-archive-calameo',
    templateUrl: './archive-calameo.component.html',
    styleUrls: ['./archive-calameo.component.scss'],
    providers: [ArchiveService],
    standalone: true,
    imports: [DatePipe]
})
export class ArchiveCalameoComponent implements OnInit {

  @Input() calameoiFrameUrl: string;
  @Input() newsPaperName: string;
  @Input() newsPaperDate: string;

  public iFrameCalameoSrc: SafeResourceUrl;

  constructor(public activeModal: NgbActiveModal, public archiveService: ArchiveService, private domSanitization: DomSanitizer) {}

  ngOnInit() {
    this.archiveService.getCalameoUrlForIframe(this.calameoiFrameUrl).subscribe({
      next: (url: { link: string }) => this.iFrameCalameoSrc = this.domSanitization.bypassSecurityTrustResourceUrl(url.link),
      error: (error) => console.log(error)
    })
  }
}
